import type { ServiceSubSelectDto } from '@@types/api.types';
import { countries } from '@utils/constants';

type AvatarItem = {
  altText: string;
  imageUrl?: string;
  initialText: string;
  tooltip: string;
};

type MissionRequestCountryDisplay = {
  names: string[];
  text?: string;
};

export const getMissionRequestCountryDisplay = (countryCodes?: string[]): MissionRequestCountryDisplay => {
  if (!countryCodes || countryCodes.length === 0) {
    return { names: [] };
  }

  const names = countryCodes
    .map((countryCode) => {
      const country = countries.find((item) => item.code === countryCode);
      return country?.name ?? countryCode;
    })
    .filter(Boolean);

  return {
    names,
    text: names.length > 0 ? names.join(', ') : undefined,
  };
};

export const buildMissionRequestServiceAvatarItems = (services?: ServiceSubSelectDto[]): AvatarItem[] => {
  if (!services || services.length === 0) {
    return [];
  }

  return services.map((service) => {
    let tooltip = service.name;

    if (service.parentService?.name) {
      const country = countries.find((item) => item.name === service.parentService?.name);
      const countryCode = country?.code ?? service.parentService.name;
      tooltip = `${countryCode} - ${service.name}`;
    }

    return {
      altText: service.name,
      imageUrl: service.slug ? `/images/services/${service.slug}.png` : undefined,
      initialText: service.name,
      tooltip,
    };
  });
};
